import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeDocumentRoute extends Route {
  @service store;
  @service router;

  initiativeDocVersionAdapter = this.store.adapterFor(
    'initiative-document-version',
  );

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      const editorWasInEditMode = controller.get('editMode');
      if (editorWasInEditMode) controller.get('model').save();
      else clearTimeout(controller.get('populateEditorTimeout'));
      controller.set('editMode', false);
      controller.set('selectedVersion', null);
      controller.set('showNotification', false);
      controller.get('notificationTimeout') &&
        clearTimeout(controller.get('notificationTimeout'));
    }
  }

  model() {
    const model = this.modelFor('backlog.initiatives.initiative');
    return model;
  }
}

export default instrumentRoutePerformance(RoadmapTableInitiativeDocumentRoute);
